<template>
  <div class="invoice-form">
    <Grid gtc="repeat(4, 1fr)" gtr="1fr 1fr" gap="var(--r-space-md)">
      <RInput v-model="invoice.invoice_number" label="Invoice number" no-feedback-icon no-hint />
      <RInput v-model="invoice.voucher_number" label="Voucher number" no-feedback-icon no-hint />
      <RInput v-model="invoice.reference_number" label="Reference number" no-feedback-icon no-hint />
      <RDropdown
        v-model="invoice.currency"
        :options="settings.options.currencies"
        emit-value
        no-hint
        label="Currency"
        map-options
      />
      <RInput
        id="amount"
        :value="formattedAmount"
        label="Amount"
        no-feedback-icon
        no-hint
        on-clear="focus"
        @clear="clearAmount"
        @input="amountManuallyChanged"
      />
      <RInput v-model="invoice.issue_date" label="Issue date" is-date no-feedback-icon no-hint />
      <RInput v-model="invoice.due_date" label="Due date" is-date no-feedback-icon no-hint />
      <FileUploader v-model="invoice.file" stack-label="Invoice file" />
    </Grid>
  </div>
</template>

<script>
import { cleaveInstance } from '@/utils/cleave-instance'
// Components
import FileUploader from '@/reusable/FileUploader/FileUploader'

export default {
  components: {
    FileUploader
  },

  props: {
    quickView: Object
  },

  data: () => ({
    formattedAmount: null,
    amountEnteredManually: false,
    invoice: {
      currency: null,
      amount: null,
      invoice_number: null,
      voucher_number: null,
      reference_number: null,
      issue_date: null,
      due_date: null,
      file: null
    }
  }),

  watch: {
    'invoice.currency'(newVal) {
      this.$emit('currency-changed', newVal)
    },
    'invoice.amount'(newVal) {
      this.$emit('amount-changed', newVal)
    }
  },

  created() {
    this.invoice.currency = this.quickView.provider.currency
  },

  mounted() {
    this.amountCleave = cleaveInstance.call(this, '#amount .input-component .q-field__native', ({ target }) => {
      this.invoice.amount = target.rawValue || null
      this.formattedAmount = target.value || null
    })
  },

  methods: {
    // access from parent
    getInvoice() {
      const formatDate = this.formatDateForPost
      const invoice = { ...this.invoice }

      invoice.issue_date = invoice.issue_date ? formatDate(invoice.issue_date, this.settings.date_format) : null
      invoice.due_date = invoice.due_date ? formatDate(invoice.due_date, this.settings.date_format) : null
      invoice.amount = invoice.amount ? Number(invoice.amount) : null

      return invoice
    },

    // access from parent
    setAmount(newAmount) {
      if (!this.amountEnteredManually) this.amountCleave.setRawValue(newAmount)
    },

    clearAmount() {
      this.amountCleave.setRawValue(null)
    },

    amountManuallyChanged(newVal) {
      this.amountEnteredManually = !!parseInt(newVal)
    }
  }
}
</script>
